var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, reaction } from "mobx";
import { execFunction } from "../../../helpers";
export class DropdownEmbeddableController {
    constructor(config) {
        this.isOpen = false;
        this.hideListHandler = () => {
            this.isOpen = false;
        };
        this.showListHandler = (e) => {
            e.stopPropagation();
            this.isOpen = true;
        };
        this.clickHandler = (e) => {
            e.stopPropagation();
        };
        this.getInitialItem = () => {
            const item = this.data.find((x) => !!x.selected) || { value: "", label: "" };
            return {
                value: item.value || "",
                label: item.label || ""
            };
        };
        this.makeChoice = (e) => {
            this.isOpen = false;
            const target = e.target;
            const label = target.textContent || "";
            const value = target.getAttribute("data-value") || "";
            this.setSelected(value, label);
        };
        this.makeChoiceNative = (e) => {
            this.isOpen = false;
            const target = e.target;
            const label = target.options[target.selectedIndex].text || "";
            const value = target.value || "";
            this.setSelected(value, label);
        };
        this.data = config.data;
        this.onChangeCallback = config.onChangeCallback;
        this.selected = this.getInitialItem();
        this.id = config.id;
    }
    activate() {
        this.disposeOnValueChange = reaction(() => this.selected, () => execFunction(this.onChangeCallback, [this.id, this.selected.value]));
    }
    deactivate() {
        this.disposeOnValueChange();
    }
    setSelected(value, label) {
        this.selected = {
            value,
            label
        };
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], DropdownEmbeddableController.prototype, "isOpen", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DropdownEmbeddableController.prototype, "selected", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], DropdownEmbeddableController.prototype, "setSelected", null);
//# sourceMappingURL=DropdownEmbeddableController.js.map